export const OMISSION_HOLES = [...Array.from({ length: 999 - 165 + 1 }, (_, i) => `250507-${165 + i}`), ...Array.from({ length: 257 }, (_, i) => `250508-${(i + 1).toString().padStart(3, '0')}`)];
